import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import '../styles/ManageRolesPage.css';
import Panel from '../components/Panel';
import axios from '../services/axiosConfig';

const ConfigRolesToMenu = () => {
  // API URL from environment variable only
  const API_URL = process.env.REACT_APP_API_URL;
  
  // State for menu mapping
  const [internalRoles, setInternalRoles] = useState([]);
  const [menuInternalRole, setMenuInternalRole] = useState(null);
  const [menuExternalRoles, setMenuExternalRoles] = useState([]);
  const [menuItems, setMenuItems] = useState([]);
  const [filteredMenuItems, setFilteredMenuItems] = useState([]);
  const [menuFilter, setMenuFilter] = useState('');
  const [mappedMenuInput, setMappedMenuInput] = useState('');
  const [menuData, setMenuData] = useState([]); // State for mapped menu input
// Define the state and function for toggling the panel
const [isPanelOpen, setIsPanelOpen] = useState(true);

const togglePanel = () => {
  setIsPanelOpen((prevState) => !prevState);
};


  // Add useEffect to fetch menu data
useEffect(() => {
  const fetchMenuData = async () => {
    try {
      const response = await axios.get(`${API_URL}/manageroles/GetLoadMappedMenus`);
      if (response.status === 200) {
        const rawMenuData = response.data.menuItems; // Use menuItems from the response

        // Recursive function to build the menu hierarchy
        const buildMenuHierarchy = (parentId) => {
          return rawMenuData
            .filter((item) => item.parentId === parentId)
            .map((item) => ({
              ...item,
              children: buildMenuHierarchy(item.childId), // Recursively attach children
            }));
        };
        const processedMenuData = buildMenuHierarchy(null); // Start with top-level items
 setMenuData(processedMenuData);
      } else {
        throw new Error(`Unexpected response status: ${response.status}`);
      }
    } catch (error) {
      console.error('Error fetching menu data:', error);
      // toast.error('Failed to fetch menu data');
    }
  };
  fetchMenuData();
}, []);
  // Update the logic to fetch and populate internal roles dropdown
  useEffect(() => {
    const loadInternalRoles = async () => {
      try {
        const response = await axios.get(`${API_URL}/ConfigExternalRoles/LoadInternalRoles`);
        const roles = response.data.internalRoles;

        // Transform data for dropdown
        const options = roles.map(role => ({
          id: role.id,
          roleName: role.roleName
        }));

        setInternalRoles(options);
      } catch (error) {
        console.error('Error loading internal roles:', error);
        // toast.error('Failed to load internal roles');
      }
    };
    loadInternalRoles();
  }, []);
  // Fetch mapped external roles for menu mapping
  useEffect(() => {
    if (menuInternalRole) {
        const fetchMappedRoles = async () => {
        try {
          const response = await axios.get(`${API_URL}/ManageRoles/GetMappedRoles?internalRoleId=${menuInternalRole}`);
          if (response.status === 200 && response.data.success) {
            const roles = response.data.mappedExternalRoles.map(role => ({
              value: role.externalRoleId,
              label: role.externalRoleName,
              externalMappedId: role.externalMappedId, // Assign externalMappedId
              selected: role.checked,
            }));
            setMenuExternalRoles(roles);
          } else {
            console.error('Failed to fetch mapped roles:', response.data);
          }
        } catch (error) {
          console.error('Error fetching mapped roles:', error);
        }
      };
        const fetchMenuData = async () => {
        try {
          const response = await axios.get(`${API_URL}/manageroles/GetLoadMappedMenus`);
          if (response.status === 200) {
            const rawMenuData = response.data.menuItems; // Use menuItems from the response
              // Recursive function to build the menu hierarchy
            const buildMenuHierarchy = (parentId) => {
              return rawMenuData
                .filter((item) => item.parentId === parentId)
                .map((item) => ({
                  ...item,
                  children: buildMenuHierarchy(item.childId), // Recursively attach children
                }));
            };
              const processedMenuData = buildMenuHierarchy(null); // Start with top-level items
          setMenuData(processedMenuData);
          } else {
            throw new Error(`Unexpected response status: ${response.status}`);
          }
        } catch (error) {
          console.error('Error fetching menu data:', error);
          // toast.error('Failed to fetch menu data');
        }
      };
        fetchMappedRoles();
      fetchMenuData();
    } else {
      setMenuExternalRoles([]);
      setMenuData([]); // Clear menuData when no internal role is selected
    }
  }, [menuInternalRole]);
   const handleMenuRoleCheckboxChange = async (roleId, isChecked) => {
    setMenuExternalRoles((prevRoles) =>
      prevRoles.map((role) =>
        role.value === roleId ? { ...role, selected: isChecked } : role
      )
    );
    try {
      const role = menuExternalRoles.find((r) => r.value === roleId);
      if (role) {
        if (!isChecked) {
          const response = await axios.get(`${API_URL}/manageroles/GetLoadMappedMenus`);
          if (response.status === 200) {
            const rawMenuData = response.data.menuItems;
            const buildMenuHierarchy = (parentId) => {
              return rawMenuData
                .filter((item) => item.parentId === parentId)
                .map((item) => ({
                  ...item,
                  children: buildMenuHierarchy(item.childId),
                }));
            };
            const processedMenuData = buildMenuHierarchy(null);
            setMenuData(processedMenuData);
          } else {
            throw new Error(`Unexpected response status: ${response.status}`);
          }
        } else {
          const payload = {
            CheckedRoles: [
              {
                Value: role.externalMappedId,
                Checked: isChecked,
              },
            ],
          };
          const response = await axios.post(
            `${API_URL}/manageroles/GetCheckedMenus`,
            payload
          );
          if (response.status === 200) {
            const { selectMenuList, reportsItemList, stateList } = response.data;
            // Logic for selectMenuList
            const parsedSelectMenuList = selectMenuList.map((item) => {
              const [childId, parentId, itemName] = item.split(', ').map((entry) => entry.split(': ')[1]);
              return { childId: parseInt(childId, 10), parentId: parentId.trim(), itemName };
            });
            const updatedMenuDataForSelectMenuList = menuData.map((menuItem) => {
              let updatedMenuItem = { ...menuItem };
              const matchingItem = parsedSelectMenuList.find(
                (selectItem) => selectItem.parentId === '' && selectItem.itemName === menuItem.itemName
              );
              if (matchingItem) {
                updatedMenuItem = {
                  ...updatedMenuItem,
                  checked: isChecked,
                };
              }
                const parentMatches = parsedSelectMenuList.filter((selectItem) =>
                selectItem.parentId === String(menuItem.childId)
              );
              if (parentMatches.length > 0) {
                let children = updatedMenuItem.children || [];
                parentMatches.forEach((parentMatch) => {
                  const childMatch = children.find((child) => child.itemName === parentMatch.itemName);
                  if (childMatch) {
                    children = children.map((child) =>
                      child.itemName === parentMatch.itemName
                        ? { ...child, checked: isChecked }
                        : child
                    );
                  } else if (isChecked) {
                    children.push({
                      childId: parentMatch.childId,
                      itemName: parentMatch.itemName,
                      checked: true,
                    });
                  }
                });
                updatedMenuItem = {
                  ...updatedMenuItem,
                  children,
                };
              }
              return updatedMenuItem;
            });
            // Logic for reportsItemList
            const parsedReportsItemList = reportsItemList.map((item) => {
              const [parentId, reportId, itemName] = item.split(', ').map((entry) => entry.split(': ')[1]);
              return { parentId: parseInt(parentId, 10), reportId: parseInt(reportId, 10), itemName };
            });
            const updatedMenuDataForReportsItemList = updatedMenuDataForSelectMenuList.map((menuItem) => {
              let updatedMenuItem = { ...menuItem };
  
              const reportMatches = parsedReportsItemList.filter((reportItem) =>
                reportItem.parentId === menuItem.childId &&
                menuItem.children.some((child) => child.itemName === reportItem.itemName)
              );
  
              if (reportMatches.length > 0) {
                updatedMenuItem.children = updatedMenuItem.children.map((child) => {
                  const matchingReport = reportMatches.find((reportItem) => reportItem.itemName === child.itemName);
                  if (matchingReport) {
                    return { ...child, checked: true };
                  }
                  return child;
                });
              }
  
              return updatedMenuItem;
            });
  
            // Logic for stateList
            const parsedStateList = stateList.map((item) => {
              const [grandParentId, itemName, restrictionId, stateCode] = item.split(', ').map((entry) => entry.split(': ')[1]);
              return {
                grandParentId: parseInt(grandParentId, 10),
                itemName,
                restrictionId: parseInt(restrictionId, 10),
                stateCode,
              };
            });
  
            const updatedMenuDataForStateList = updatedMenuDataForReportsItemList.map((menuItem) => {
              let updatedMenuItem = { ...menuItem };
  
              const stateMatches = parsedStateList.filter((stateItem) =>
                stateItem.grandParentId === menuItem.childId &&
                menuItem.children.some((child) => child.itemName === stateItem.itemName)
              );
  
              if (stateMatches.length > 0) {
                updatedMenuItem.children = updatedMenuItem.children.map((child) => {
                  const matchingStates = stateMatches.filter((stateItem) => stateItem.itemName === child.itemName);
                  if (matchingStates.length > 0 && child.children) {
                    child.children = child.children.map((innerChild) => {
                      const isStateCodeMatched = matchingStates.some((stateItem) => innerChild.itemName === stateItem.stateCode);
                      return isStateCodeMatched ? { ...innerChild, checked: true } : innerChild;
                    });
                  }
                  return child;
                });
              }
  
              return updatedMenuItem;
            });
            setMenuData(updatedMenuDataForStateList);
          } else {
            throw new Error(`Unexpected response status: ${response.status}`);
          }
        }
      }
    } catch (error) {
      console.error('Error updating menu data:', error);
      // toast.error('Failed to update menu data');
    }
  };

  const calculateCheckboxState = (item) => {
    if (!item.children || item.children.length === 0) {
      return item.checked ? 'checked' : 'unchecked';
    }
  
    const allChildrenChecked = item.children.every((child) => calculateCheckboxState(child) === 'checked');
    const someChildrenChecked = item.children.some((child) => calculateCheckboxState(child) !== 'unchecked');
  
    if (allChildrenChecked) {
      return 'checked'; // All children are checked
    } else if (someChildrenChecked) {
      item.checked = true; // Ensure checked is true for indeterminate state
      return 'indeterminate'; // Some children are checked or parent is checked
    } else {
      return 'unchecked'; // None of the children are checked
    }
  };

    // Save mapped menu items for a role
  // Save mapped menu items for a role
  const saveMenuMappings = async () => {
    const collectCheckedItems = (items) => {
      return items
        .filter((item) => item.checked) // Include only checked items
        .map((item) => ({
          text: item.itemName,
          value: item.parentId === null ? String(item.childId || '') : '',
          checked: item.checked,
          children: item.children && item.children.length > 0 ? collectCheckedItems(item.children) : undefined,
        }));
    };

    const checkedMenuData = collectCheckedItems(menuData); // Collect checked items from the entire menuData

    const payload = {
      checkedExternalRoles: [
        {
          internalRoleId: String(menuInternalRole),
          internalRoleName: internalRoles.find((role) => role.id === menuInternalRole)?.roleName || '',
          internalRoleDesc: 'null',
          checked: true,
          externalMappedId: menuExternalRoles.find((role) => role.selected)?.value || '',
        },
      ],
      menuItems: checkedMenuData,
    };

    try {
      const response = await axios.post(
        `${API_URL}/ManageRoles/SaveMenuMapping`,
        payload,
        {
          headers: {
            'Content-Type': 'application/json'
          }
        }
      );
      if (response.status === 200) {
        toast.success('Menu mappings saved successfully');
      } else {
        console.error('Error Response:', response.data);
        // toast.error('Failed to save menu mappings');
      }
    } catch (error) {
      console.error('Error:', error);
      // toast.error('An error occurred while saving menu mappings');
    }
   };

   
   const renderMenuItems = (menuItems) => {
     if (!menuItems || menuItems.length === 0) {
       return null; // Return null if menuItems is null or empty
     }
   
     return menuItems.map((item) => {
       const checkboxRef = React.createRef();
       const checkboxState = calculateCheckboxState(item);
   
       // Set the indeterminate property directly
       setTimeout(() => {
         if (checkboxRef.current) {
           checkboxRef.current.indeterminate = checkboxState === 'indeterminate';
         }
       }, 0);

       // Ensure selecting a parent item selects all its children and their descendants recursively
const handleCheckboxChange = (childId, isChecked) => {
  setMenuData((prevMenuData) => {
    const updateMenuItems = (items) => {
      return items.map((item) => {
        if (item.childId === childId) {
          return {
            ...item,
            checked: isChecked,
            children: item.children
              ? updateMenuItems(item.children).map((child) => ({
                  ...child,
                  checked: isChecked,
                  children: child.children
                    ? updateMenuItems(child.children).map((grandChild) => ({
                        ...grandChild,
                        checked: isChecked,
                      }))
                    : [],
                }))
              : [],
          };
        }
        return {
          ...item,
          children: item.children ? updateMenuItems(item.children) : item.children,
        };
      });
    };

    return updateMenuItems(prevMenuData);
  });
};
   
       return (
         <div key={item.childId} className="menu-item">
           {item.children && item.children.length > 0 && (
             <span 
               className="menu-item-toggle" 
               onClick={() => handleParentToggle(item.childId)}
               onKeyDown={(e) => {
                 if (e.key === 'Enter' || e.key === ' ') {
                   e.preventDefault();
                   handleParentToggle(item.childId);
                 }
               }}
               tabIndex="0"
               role="button"
               aria-expanded={expandedParentIds.includes(item.childId)}
               aria-label={`${expandedParentIds.includes(item.childId) ? 'Collapse' : 'Expand'} menu item`}
             >
               {expandedParentIds.includes(item.childId) ? '▼' : '▶'}
             </span>
           )}
           <input
             type="checkbox"
             id={`menu-item-${item.childId}`}
             value={item.childId}
             checked={checkboxState === 'checked'}
             ref={checkboxRef}
             onChange={(e) => handleCheckboxChange(item.childId, e.target.checked)}
           />
           <label htmlFor={`menu-item-${item.childId}`} className="menu-item-label">{item.itemName}</label>
           {expandedParentIds.includes(item.childId) && item.children && item.children.length > 0 && (
             <div className="menu-child-items">
               {renderMenuItems(item.children)}
             </div>
           )}
         </div>
       );
     });
   };

   
   useEffect(() => {
   }, [menuData]);

   // Add functionality to display child items when a parent item is clicked
   const [selectedParentId, setSelectedParentId] = useState(null);
   
   // Function to handle parent item click
   const handleParentClick = (parentId) => {
     setSelectedParentId(parentId);
   };
   
   // Add functionality to toggle child items
   const [expandedParentIds, setExpandedParentIds] = useState([]);
   // Function to handle parent item toggle
const handleParentToggle = (parentId) => {
    setExpandedParentIds((prevExpanded) => {
      if (prevExpanded.includes(parentId)) {
        return prevExpanded.filter((id) => id !== parentId);
      } else {
        return [...prevExpanded, parentId];
      }
    });
  };
  
  useEffect(() => {
    const filterMenuItems = (items) => {
      return items
        .filter((item) => {
          const matchesParent = item.itemName.toLowerCase().includes(mappedMenuInput.toLowerCase());
          const matchesChildren = item.children && item.children.some((child) => child.itemName.toLowerCase().includes(mappedMenuInput.toLowerCase()));

          return matchesParent || matchesChildren;
        })
        .map((item) => ({
          ...item,
          children: item.children ? filterMenuItems(item.children) : [],
        }));
    };

    if (mappedMenuInput.trim() === '') {
      setFilteredMenuItems(menuData); // Show all menu items if the input is empty
    } else {
      const filtered = filterMenuItems(menuData);
      setFilteredMenuItems(filtered);
    }
  }, [mappedMenuInput, menuData]);
  
  return (
    <Panel title={
      <div className="panel-title-container">
        <span className="panel-title-text">Config Roles to Menu</span>
        <span
          className="panel-toggle"
          onClick={togglePanel}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              togglePanel();
            }
          }}
          tabIndex="0"
          role="button"
          aria-expanded={isPanelOpen}
          aria-label={`${isPanelOpen ? 'Collapse' : 'Expand'} Config Roles to Menu panel`}
        >
          {isPanelOpen ? '▼' : '▶'}
        </span>
      </div>
    }>
      {isPanelOpen && (
      <div className="config-roles-menu">
        <div className="config-roles-menu-content">
          <div className="config-roles-menu-form-column">
            <div className="config-roles-menu-form-row">
              <label>Select Internal Roles</label>
              <select
                className="form-control config-roles-menu-select"
                value={menuInternalRole || ''}
                onChange={(e) => setMenuInternalRole(e.target.value ? Number(e.target.value) : null)}
              >
                <option value="">Select</option>
                {internalRoles.map((role) => (
                  <option key={role.id} value={role.id}>{role.roleName}</option>
                ))}
              </select>
            </div>
            <div className="config-roles-menu-form-row-narrow">
              <label>Mapped External Roles</label>
              <div className="config-roles-menu-mapped-container">
                <div>
                  <input
                    type="checkbox"
                    id="select-all-menu-roles"
                    checked={menuExternalRoles.length > 0 && menuExternalRoles.every((role) => role.selected)}
                    onChange={(e) => {
                      const isChecked = e.target.checked;
                      setMenuExternalRoles(menuExternalRoles.map((role) => ({ ...role, selected: isChecked })));
                    }}
                  />
                  <label htmlFor="select-all-menu-roles">Select All</label>
                </div>
                <ul className="config-roles-menu-list">
                  {menuExternalRoles.map((role) => (
                    <li key={role.value} className="role-item config-roles-menu-list-item">
                      <input
                        type="checkbox"
                        id={`menu-role-${role.value}`}
                        value={role.value}
                        checked={role.selected || false}
                        onChange={(e) => handleMenuRoleCheckboxChange(role.value, e.target.checked)}
                      />
                      <label htmlFor={`menu-role-${role.value}`}>{role.label}</label>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
            <div className="config-roles-menu-form-row-wide">
              <label>Mapped Menu</label>
              <input
                type="text"
                className="form-control config-roles-menu-input"
                placeholder="Filter Reports..."
                value={mappedMenuInput}
                onChange={(e) => setMappedMenuInput(e.target.value)}
              />
            </div>
          </div>
        </div>
        <div className="config-roles-menu-data">
          {filteredMenuItems && filteredMenuItems.length > 0 && renderMenuItems(filteredMenuItems)}
        </div>

        <div className="button-container-center">
          <button 
            className="gray-button"
            onClick={saveMenuMappings}
          >
            Save
          </button>
          <button 
            className="gray-button"
          >
            Cancel
          </button>
        </div>
      </div>
      )}
    </Panel>
  );
};

export default ConfigRolesToMenu;